export const sideMenuWidth = 260;
export const mediumSideMenuWidth = 160;
